import React from 'react';
import { t } from '../../l10n/l10n';
import { Button, Dialog } from '@economic/taco';

interface Props {
    text: string;
    onDone: () => void;
}

export default function StepSucess({ text, onDone }: Props) {
    return (
        <div>
            <Dialog.Title>{t`FORM_COMPANY_DEREGISTER_SUCCESS_TITLE`}</Dialog.Title>
            <div style={{ textAlign: 'center' }}>
                <div>{text}</div>
            </div>
            <Dialog.Footer>
                <Button appearance="ghost" onClick={onDone}>
                    {t('FORM_COMPANY_DEREGISTER_SUCCESS_CLOSE')}
                </Button>
            </Dialog.Footer>
        </div>
    );
}
